// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uJBvxkN1o9Y6OqiP {
  padding: 32px 24px;
}
.pmvsG3PGQo_QT0ss {
  max-width: 760px;
  margin: 0 auto;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 34, 66, 0.06);
}
.ZX8zlQoU8YIDJZK5 {
  margin-bottom: 24px;
  padding: 24px 24px 0;
}
.WDMHLYW0AGgPlWXn {
  border-radius: 12px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #f5f9ff 0%, #f9fbff 100%);
  border: 1px solid #e6f0ff;
}
.UCvLXBpeQ1U9kXQy {
  display: inline-flex;
  align-items: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
}
.Y71RumNTyWIbpOJN {
  background: rgba(22, 119, 255, 0.12);
  color: #1677ff;
}
.tSzvr7E7BuAuejkI {
  background: rgba(250, 173, 20, 0.14);
  color: #d48806;
}
.qbFSNEqCTH4ZWHAI {
  background: rgba(255, 77, 79, 0.12);
  color: #cf1322;
}
.GELvb7ihTIwMs5pS {
  background: rgba(0, 0, 0, 0.06);
  color: #595959;
}
.H8gcVGfl2A2cWVgA {
  margin-top: 12px;
  font-size: 20px;
  line-height: 30px;
  font-weight: 600;
  color: #1f1f1f;
}
.L2zjgEabFgsXIrmC {
  text-align: center;
  max-width: 480px;
  margin: 0 auto;
}
.jWobVjx2dJs18sfz {
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: #1f1f1f;
  margin-bottom: 12px;
}
.S2ILyEOyVjU_jqAs {
  color: #666;
  line-height: 24px;
}
.dbESBY27zaUHEDn1 {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/noAccess/index.modules.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAEA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;AAAF;AAGA;EACE,mBAAA;EACA,oBAAA;AADF;AAIA;EACE,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,yBAAA;AAFF;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAMA;EACE,oCAAA;EACA,cAAA;AAJF;AAOA;EACE,oCAAA;EACA,cAAA;AALF;AAQA;EACE,mCAAA;EACA,cAAA;AANF;AASA;EACE,+BAAA;EACA,cAAA;AAPF;AAUA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AARF;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AATF;AAYA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAVF;AAaA;EACE,WAAA;EACA,iBAAA;AAXF;AAcA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAZF","sourcesContent":[".page {\n  padding: 32px 24px;\n}\n\n.card {\n  max-width: 760px;\n  margin: 0 auto;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(15, 34, 66, 0.06);\n}\n\n.hero {\n  margin-bottom: 24px;\n  padding: 24px 24px 0;\n}\n\n.heroInner {\n  border-radius: 12px;\n  padding: 20px 24px;\n  background: linear-gradient(135deg, #f5f9ff 0%, #f9fbff 100%);\n  border: 1px solid #e6f0ff;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  height: 28px;\n  padding: 0 12px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.badgePrimary {\n  background: rgba(22, 119, 255, 0.12);\n  color: #1677ff;\n}\n\n.badgeWarning {\n  background: rgba(250, 173, 20, 0.14);\n  color: #d48806;\n}\n\n.badgeDanger {\n  background: rgba(255, 77, 79, 0.12);\n  color: #cf1322;\n}\n\n.badgeNeutral {\n  background: rgba(0, 0, 0, 0.06);\n  color: #595959;\n}\n\n.subTitle {\n  margin-top: 12px;\n  font-size: 20px;\n  line-height: 30px;\n  font-weight: 600;\n  color: #1f1f1f;\n}\n\n.description {\n  text-align: center;\n  max-width: 480px;\n  margin: 0 auto;\n}\n\n.title {\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 600;\n  color: #1f1f1f;\n  margin-bottom: 12px;\n}\n\n.text {\n  color: #666;\n  line-height: 24px;\n}\n\n.actions {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `uJBvxkN1o9Y6OqiP`,
	"card": `pmvsG3PGQo_QT0ss`,
	"hero": `ZX8zlQoU8YIDJZK5`,
	"heroInner": `WDMHLYW0AGgPlWXn`,
	"badge": `UCvLXBpeQ1U9kXQy`,
	"badgePrimary": `Y71RumNTyWIbpOJN`,
	"badgeWarning": `tSzvr7E7BuAuejkI`,
	"badgeDanger": `qbFSNEqCTH4ZWHAI`,
	"badgeNeutral": `GELvb7ihTIwMs5pS`,
	"subTitle": `H8gcVGfl2A2cWVgA`,
	"description": `L2zjgEabFgsXIrmC`,
	"title": `jWobVjx2dJs18sfz`,
	"text": `S2ILyEOyVjU_jqAs`,
	"actions": `dbESBY27zaUHEDn1`
};
export default ___CSS_LOADER_EXPORT___;
